import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Hyrox from "@/pages/Hyrox";
import Schedule from "@/pages/Schedule";
import Join from "@/pages/Join";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <a
          href="#main-content"
          className="skip-to-content"
          data-testid="skip-to-content"
        >
          Skip to main content
        </a>
        <Header />
        <main id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/hyrox" element={<Hyrox />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/join" element={<Join />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <MobileCTA />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
